import {
    getConfigurableVariant,
    getCategoryPath,
    getCartItemPrice,
    getPlpItemCategory
} from '@airglobal/pylot-gtm/src/mapping/functions'
import { MappingItem } from '@airglobal/pylot-gtm/src/GTM'
import {
    CartItemInterface,
    ConfigurableCartItem,
    ConfigurableProduct,
    ProductInterface
} from '@pylot-data/pylotschema'
import { deepValue, itemHasKey } from '@corratech/pylot-utils'

const isConfigurableCartItem = (
    item: CartItemInterface
): item is ConfigurableCartItem => {
    return itemHasKey(item, 'configurable_options')
}

const isConfigurableProduct = (
    product: ProductInterface
): product is ConfigurableProduct => {
    return itemHasKey(product, 'variants')
}

const getItemSubscriptionFrequency = (item: CartItemInterface) => {
    const product = item?.product
    if (!product) {
        return ''
    }
    return item.subscription_data?.billing_period ?? 'NA'
}

const getItemSku = (item: CartItemInterface): string => {
    const product = item?.product
    if (!product) {
        return ''
    }
    if (
        !isConfigurableCartItem(item) ||
        !isConfigurableProduct(product) ||
        !Array.isArray(product?.variants)
    ) {
        return String(product?.sku)
    }
    return String(product?.sku)
}

const getItemCategory = (item: CartItemInterface): string =>
    item?.product ? getPlpItemCategory(item.product) : ''

const getItemCategory2 = (item: CartItemInterface): string => {
    return String(deepValue(item, ['product', 'attribute_set_name'], ''))
}

export const cartItemMapping = (
    itemCategoryPath = getCategoryPath,
    cartItemPrice = getCartItemPrice,
    configurableVariant = getConfigurableVariant
): MappingItem => {
    return {
        id: getItemSku,
        name: ['product', 'name'],
        price: cartItemPrice,
        quantity: ['quantity'],
        item_category: getItemCategory,
        item_category2: getItemCategory2,
        subscription_frequency: getItemSubscriptionFrequency,
        currencyCode: [
            ['price_range', 'minimum_price', 'final_price', 'currency'],
            ['prices', 'row_total_including_tax', 'currency']
        ],
        variant: configurableVariant,
        brand: ['product', 'brand_text']
    }
}
